import { Injectable } from '@angular/core';

export class BreadCrumb {
  name: string;
  href?: string;
  color?: string;
}

@Injectable()
export class BreadCrumbsService {
  crumbs: BreadCrumb[] = [];

  public create(crumbs?: BreadCrumb[]) {
    this.crumbs = [{
      name: 'Магазин',
      href: '/',
      color: 'general-primary'
    }];

    if (crumbs) {
      this.crumbs = this.crumbs.concat(crumbs);
    }
  }
}
